import { reducer, setAppLoading, setDisableAppLoading } from 'src/redux/pageDecision/pageDecision.slice'

export default {
  reducer,
  setAppLoading,
  setDisableAppLoading,
}
